<template>
  <v-main>
    <v-container fluid>
      <v-btn
        fab
        x-small
        class="mx-2 mb-2"
        color="white"
        @click="$router.back()"
      >
        <v-icon light> mdi-arrow-left </v-icon>
      </v-btn>
      <v-row justify="center">
        <v-col md="12" lg="12" sm="6" class="px-0 pb-0">
          <!-- Main Container -->
          <v-card
            class="mt-4 mb-0 pb-0"
            rounded="xl"
            color="blue lighten-5"
            width="auto"
            min-height="430"
          >
            <v-row class="ma-0">
              <v-col class="pa-0">
                <h2 class="mx-4 my-4" style="width: 250px">
                  Visiting Report Lists
                </h2>
              </v-col>
              <v-col
                class="pa-0 ma-2"
                v-if="user.roles[0].name == 'Supervisor'"
              >
                <v-fab-transition>
                  <v-btn
                    to="/visit-reports/create"
                    color="blue lighten-5"
                    dark
                    absolute
                    fab
                    width="50"
                    height="50"
                  >
                    <v-icon color="blue">mdi-plus</v-icon>
                  </v-btn>
                </v-fab-transition>
              </v-col>
            </v-row>
            <template v-if="visit_reports.length > 0">
              <v-row class="ma-0">
                <v-col class="pa-0 mx-3 mb-6">
                  <v-expansion-panels>
                    <v-expansion-panel
                      v-for="visit_report in visit_reports"
                      :key="visit_report.id"
                    >
                      <v-expansion-panel-header>
                        <v-row class="ma-0">
                          <v-col cols="10" class="pa-0"
                            ><span>{{ visit_report.site.name }}</span>
                          </v-col>
                          <v-col
                            cols="2"
                            class="pa-0"
                            align="right"
                            v-if="user.roles[0].name == 'Supervisor'"
                            ><v-fab-transition>
                              <v-btn
                                :to="`/visit-reports/${visit_report.id}`"
                                color="blue lighten-5"
                                dark
                                fab
                                x-small
                              >
                                <v-icon color="blue">mdi-pencil</v-icon>
                              </v-btn>
                            </v-fab-transition></v-col
                          >
                        </v-row>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Date</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.date | ddmmyyyy }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Site Location</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.site_location }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Total Manpower</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.total_manpower }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Total Present</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.total_present }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Shortage Manpower</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.shortage_manpower }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Total HK Boys</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.total_hk_boys }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Total CM</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.total_cm }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Total Pantry Boy</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.total_pantry_boy }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Total Office Boy</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.total_office_boy }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Total Supervisor</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.total_supervisor }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Total Reliever</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.total_reliever }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Absent Name</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.absent_name }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Staff Work</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.staff_work }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Client Visit</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.client_visit }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>New Joining Details</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span
                              >: {{ visit_report.new_joining_details }}</span
                            >
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Monday Agenda</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.monday_agenda }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Tuesday Agenda</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.tuesday_agenda }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Wednesday Agenda</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.wednesday_agenda }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Thursday Agenda</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.thursday_agenda }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Friday Agenda</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.friday_agenda }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Saturday Agenda</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.saturday_agenda }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Sunday Agenda</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.sunday_agenda }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Supervisor Name</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.supervisor_name }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Site In Time</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.site_in_time }}</span>
                          </v-col>
                        </v-row>
                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Site Out Time</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span>: {{ visit_report.site_out_time }}</span>
                          </v-col>
                        </v-row>

                        <v-row class="ma-0 py-1">
                          <v-col class="pa-0" style="max-width: 100px">
                            <span>Is Active</span>
                          </v-col>
                          <v-col class="pa-0" align="left">
                            <span
                              >:
                              {{
                                visit_report.is_active == true ? "Yes" : "No"
                              }}</span
                            >
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
            </template>
            <template v-if="visit_reports.length == 0">
              <v-row justify="center">
                <v-col align="center" style="min-height: 100px">
                  <v-progress-circular
                    v-if="isLoading == true"
                    :size="70"
                    :width="7"
                    color="blue"
                    indeterminate
                  ></v-progress-circular>
                  <span v-else> No employee found. </span>
                </v-col>
              </v-row>
            </template>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="footer-text">
      <v-row justify="center">
        <v-col align="center">
          <h3 class="white--text">We Alliance Sparkle</h3>
          <h4 class="white--text">v 1.0.0</h4>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import backbutton from "@/components/backbutton.vue";
export default {
  components: { backbutton },
  name: "UsersPage",
  data() {
    return {
      visit_reports: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let visit_reports = await axios.get(`visit_reports`);
      this.visit_reports = visit_reports.data.data;
      this.isLoading = false;
    },
  },
};
</script>
